import type { PhotoItemDto } from '@customTypes/types';

import { isPhotoItemDto } from '@/shared/constants/type-guards';

export const isPhotoItemArrayDto = (obj: unknown): obj is PhotoItemDto[] =>
  Array.isArray(obj) && obj.every(isPhotoItemDto);
